module.exports = __webpack_public_path__ + "static/media/home-lg-alt.96cbc014.svg";